import { useEffect } from "react"
import { useAuthStore } from "../stores/auth-store"

/**
 * Returns the current optimize_performance setting.
 * Also syncs a `optimize-performance` class on <body> so CSS can
 * globally disable expensive effects (backdrop-blur, slow animations).
 */
export function useOptimizePerformance() {
  const level = useAuthStore((s) => s.user?.settings?.optimize_performance ?? "off")

  useEffect(() => {
    document.body.classList.toggle("optimize-performance", level === "full")
  }, [level])

  return level
}
